import React from 'react';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { renderComponent } from 'app/src/components/ComponentWrapper';
import { LazyInviteeOrientation } from 'app/src/components/InviteeOrientation';

export const renderInviteeOrientation = ({
  $el,
  el,
  idBoard,
}: {
  $el: HTMLElement;
  el: HTMLElement;
  idBoard: string;
}) => {
  $('.board-canvas', $el).append(
    '<div class="invitee-orientation-mount-point"></div>',
  );

  // eslint-disable-next-line @trello/enforce-variable-case
  const $element = el.querySelector('.invitee-orientation-mount-point');

  if (!$element) {
    return;
  }

  return renderComponent(
    <LazyInviteeOrientation idBoard={idBoard} />,
    $element,
  );
};
